import { render, staticRenderFns } from "./MailTemplateItem.vue?vue&type=template&id=2d1d09e8"
import script from "./MailTemplateItem.vue?vue&type=script&lang=js"
export * from "./MailTemplateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports